'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _BaseListing = require('../base-components/Listing/BaseListing');

var _BaseListing2 = _interopRequireDefault(_BaseListing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('translation-listing', {

    mixins: [_BaseListing2.default],

    props: {
        label: {
            type: String,
            default: function _default() {
                return 'All groups';
            }
        }
    },

    data: function data() {
        return {

            scanning: false,

            filters: {
                group: null
            },

            translationId: null,
            translationDefault: '',
            translations: {}
        };
    },


    computed: {
        filteredGroup: function filteredGroup() {
            return this.filters.group === null ? this.label : this.filters.group;
        }
    },

    methods: {
        rescan: function rescan(url) {
            var _this = this;

            this.scanning = true;
            axios.post(url).then(function (response) {
                _this.scanning = false;
                _this.loadData(true);
            }, function (error) {
                _this.scanning = false;
                _this.$notify({ type: 'error', title: 'Error!', text: 'An error has occured.' });
            });
        },
        filterGroup: function filterGroup(group) {
            this.filters.group = group;
            this.loadData(true);
        },
        resetGroup: function resetGroup() {
            this.filters.group = null;
            this.loadData(true);
        },
        editTranslation: function editTranslation(item) {
            this.$modal.show('edit-translation', item);
        },
        beforeModalOpen: function beforeModalOpen(_ref) {
            var params = _ref.params;

            this.translationId = params.id;
            this.translationDefault = params.key;
            this.translations = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(params.text)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    this.translations[key] = params.text[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        onSubmit: function onSubmit() {
            var _this2 = this;

            var url = '/admin/translations/' + this.translationId;
            var data = {
                text: this.translations
            };

            axios.post(url, data).then(function (response) {
                _this2.$modal.hide('edit-translation');
                _this2.$notify({ type: 'success', title: 'Success!', text: 'Item successfully changed.' });
                _this2.loadData();
            }, function (error) {
                _this2.$notify({ type: 'error', title: 'Error!', text: 'An error has occured.' });
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/craftable/dist/js/translation/Listing.js
// module id = zSWl
// module chunks = 0